// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-box h6[data-v-0951c975]:first-child {\n  font-size: var(--fs-input) !important;\n  color: var(--dark-green-50, #809795);\n  font-weight: 400 !important;\n}\n.info-box h6[data-v-0951c975] {\n  font-size: var(--fs-input) !important;\n  color: var(--green);\n  font-weight: 400 !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
